import { render } from "./SpeedRegistration.vue?vue&type=template&id=cce6b39c&scoped=true"
import script from "./SpeedRegistration.vue?vue&type=script&lang=ts"
export * from "./SpeedRegistration.vue?vue&type=script&lang=ts"

import "./SpeedRegistration.vue?vue&type=style&index=0&id=cce6b39c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cce6b39c"

export default script